import React from 'react'
import { Paper, Grid } from '@mui/material'

import './ScoreTable.css'
import { sheetAccent } from '../../sheetAccents'

/**
 * ScoreTable komponent - Viser scoretavlen for Yatzy spillet
 * @param {Array} players - Array af spillere med deres scores
 * @param {number} tab - Index for den aktuelle spiller der vises
 * @param {number} minValueForBonus - Minimum værdi for at få bonus
 * @param {function} renderCategoryRows - Funktion til at rendere kategori rækker
 * @param {function} calculateScore - Funktion til at beregne score for en kategori
 * @param {function} calculateTotal - Funktion til at beregne total score
 * @param {Array} FirstCategory - Array med første kategori regler
 * @param {Array} SecondCategory - Array med anden kategori regler
 * @returns {JSX.Element} ScoreTable komponent
 */
const ScoreTable = ({ 
  players,          
  tab,              
  minValueForBonus, 
  renderCategoryRows, 
  calculateScore,    
  calculateTotal,    
  FirstCategory,     
  SecondCategory,
  gameType
}) => {
  return (
    // Hovedcontainer med semi-transparent baggrund
    <Paper
      className="score-sheet"
      elevation={3}
      style={{ '--sheet-accent': sheetAccent(tab) }}
      sx={{
        backgroundColor: 'var(--blured-field-color)',
        borderRadius: '16px',
        padding: '20px',
        color: 'var(--secondary-font-color)',
      }}
    >
      {gameType === 'fiveDice' ? (
        <div className="score-table-header-cell">
          5 Terninger
        </div>
      ) : (
        <div className="score-table-header-cell">
          6 Terninger
        </div>
      )}
      {/* Scoretabel sektion */}
      <Grid item sx={{ display: 'flex', justifyContent: 'center' }} xs={12}>
       
        <table className="score-table">
          {/* Tabel header */}
          <thead>
            <tr>
              <th className="score-table-header-cell">
                Kategori
              </th>
              <th></th>
              <th className="score-table-header-cell">
                Score
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {/* Første kategori scores */}
            {renderCategoryRows(FirstCategory, 'first', true)}
            
            {/* Sum og bonus række */}
            <tr>
              <td className="score-table-sum-row">
                Sum
              </td>
              <td className="score-table-sum-row-min-value">
                (min. {minValueForBonus})
              </td>
              <td className="score-table-sum-row-score">
                {calculateScore(players[tab].firstCategoryScores)}
              </td>
            </tr>
            <tr>
              <td className="score-table-bonus-row">Bonus</td>
              <td className="score-table-bonus-value">50</td>
              <td className={`score-table-bonus-score${calculateScore(players[tab].firstCategoryScores) >= minValueForBonus ? ' is-reached' : ''}`}>
                {calculateScore(players[tab].firstCategoryScores) >= minValueForBonus ? 50 : 0}
              </td>
            </tr>

            {/* Anden kategori scores */}
            {renderCategoryRows(SecondCategory, 'second')}
            
            {/* Total score række */}
            <tr>
              <td className="score-table-total-row">
                Total
              </td>
              <td></td>
              <td className="score-table-total-score">
                {calculateTotal(players[tab])}
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
    </Paper>
  )
}

export default ScoreTable 